<template>
    <el-dialog
        v-model="visible"
        :showClose="false"
        :closeOnClickModal="false"
        :closeOnPressEscape="false"
        width="420px"
        alignCenter
        class="subscription-success-dialog"
    >
        <div class="dialog-content">
            <!-- 成功图标 -->
            <div class="success-icon-wrapper">
                <div class="success-icon">
                    🎉
                </div>
            </div>

            <!-- 标题和副标题 -->
            <div class="text-section">
                <h2 class="success-title">
                    {{ t('payment.success.title') }}
                </h2>
                <p class="success-subtitle">
                    {{ t('payment.success.subtitle') }}
                </p>
            </div>

            <!-- 操作按钮 -->
            <div class="action-section">
                <el-button
                    type="primary"
                    size="large"
                    class="ok-button"
                    @click="handleContinue"
                >
                    {{ t('payment.success.okButton') }}
                </el-button>
            </div>

            <!-- 底部提示文字 -->
            <div class="footer-text">
                {{ t('payment.success.receiptSent') }}
            </div>
        </div>
    </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
    modelValue: boolean;
}

interface Emits {
    (e: 'update:modelValue', value: boolean): void;
    (e: 'continue'): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const { t } = useI18n();

const visible = ref(props.modelValue);

// 监听 props 变化
watch(() => props.modelValue, (newValue) => {
    visible.value = newValue;
});

// 监听 visible 变化
watch(visible, (newValue) => {
    emit('update:modelValue', newValue);
});

const handleContinue = () => {
    visible.value = false;
    emit('continue');
};
</script>

<style scoped lang="scss">
.subscription-success-dialog {
    :deep(.el-dialog) {
        border-radius: 20px;
        padding: 0;
        overflow: hidden;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    }

    :deep(.el-dialog__header) {
        display: none;
    }

    :deep(.el-dialog__body) {
        padding: 0;
    }
}

.dialog-content {
    padding: 48px 40px 32px;
    text-align: center;
}

.success-icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;

    .success-icon {
        font-size: 64px;
        line-height: 1;
        filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    }
}

.text-section {
    margin-bottom: 32px;

    .success-title {
        font-size: 24px;
        font-weight: 600;
        color: #020a1a;
        margin: 0 0 12px 0;
        line-height: 1.2;
    }

    .success-subtitle {
        font-size: 16px;
        color: #8993a4;
        margin: 0;
        line-height: 1.5;
    }
}

.action-section {
    margin-bottom: 24px;

    .ok-button {
        width: 100%;
        height: 48px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 8px;
        // 使用项目标准蓝色
        background-color: #0764e9;
        border: none;
        transition: all 0.2s ease;

        &:hover {
            background-color: #0552c4;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(7, 100, 233, 0.2);
        }

        &:active {
            background-color: #0444a5;
            transform: translateY(0);
        }
    }
}

.footer-text {
    font-size: 13px;
    color: #8993a4;
    line-height: 1.4;
}
</style>

